import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

const root = document.getElementById('root');
createRoot(root).render(
    // <React.StrictMode>
        <Router>
            <App />
        </Router>
    // </React.StrictMode>
);
